const StudentFill = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m15.926 3.966-6.75-2.25a.598.598 0 0 0-.352 0l-6.743 2.25h-.014L1.997 4H1.99l-.07.042c0 .007-.008.007-.015.014l-.056.05-.049.055c0 .008-.007.008-.007.015l-.042.063c0 .007 0 .007-.007.014l-.028.063-.021.078v.02a.26.26 0 0 0-.008.085v5.625a.562.562 0 1 0 1.125 0V5.28l2.363.788a4.5 4.5 0 0 0 1.434 6.18 6.757 6.757 0 0 0-3.27 2.63.57.57 0 0 0 .372.863.557.557 0 0 0 .571-.244 5.625 5.625 0 0 1 9.436 0 .563.563 0 0 0 .773.162.57.57 0 0 0 .17-.78 6.757 6.757 0 0 0-3.27-2.63 4.5 4.5 0 0 0 1.434-6.181l3.1-1.034a.563.563 0 0 0 0-1.068ZM9 11.813a3.375 3.375 0 0 1-3.375-3.376c.001-.72.23-1.421.654-2.003l2.545.85a.562.562 0 0 0 .352 0l2.545-.85c.424.582.653 1.283.654 2.003A3.375 3.375 0 0 1 9 11.813Z"
        fill="#9C9C9C"
      />
    </svg>
  );
};

export default StudentFill;
